<template>
  <label class="switch" :class="{ large: this.text }">
    <input
      type="checkbox"
      :checked="!!checked"
      :disabled="disabled"
      @click="$emit('click', $event)"
      @change="handleChange"
    />
    <div class="slider" :class="{ disabled, large: this.text }" :style="{ 'background-color': color }">
      <span v-if="text" class="text" :class="{ right: !checked }">{{ text }}</span>
    </div>
  </label>
</template>

<script>
/**
 * トグルスイッチ
 *
 * `<input type="checkbox">` をラップしており、その全ての props を使用できます
 */
export default {
  name: 'ToggleSwitch',
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    /** チェック状態 */
    checked: [Boolean, Number],
    /** トグル内のチェック時のテキスト */
    onText: String,
    /** トグル内の非チェック時のテキスト */
    offText: String,
    /** 活性状態 */
    disabled: Boolean,
  },
  computed: {
    color() {
      if (!this.checked) return '#ccc'
      return this.text ? '#47a3cc' : '#ffe082'
    },
    text() {
      if (!this.onText && !this.offText) return ''
      return this.checked ? this.onText : this.offText
    },
  },
  methods: {
    handleChange(e) {
      this.$emit('change', e.target.checked)
    },
  },
}
</script>

<style lang="postcss" scoped>
.switch {
  display: inline-block;
  height: 32px;
  position: relative;
  width: 56px;

  &.large {
    height: 40px;
    width: 88px;
  }

  .slider {
    background-color: var(--light-gray);
    border-radius: 34px;
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.4s;

    &::before {
      background-color: white;
      border-radius: 50%;
      content: '';
      height: 26px;
      left: 3px;
      position: absolute;
      top: 3px;
      transition: 0.4s;
      width: 26px;
    }

    &.large::before {
      height: 34px;
      width: 34px;
    }
  }

  input {
    display: none;

    &:checked + .slider.disabled {
      opacity: 0.5;
    }

    &:checked + .slider::before {
      transform: translateX(24px);
    }

    &:checked + .slider.large::before {
      transform: translateX(48px);
    }
  }

  .text {
    color: var(--white);
    font-weight: 600;
    line-height: 40px;
    margin: 0 16px;
    vertical-align: middle;

    &.right {
      position: absolute;
      right: 0;
    }
  }
}
</style>
